/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HelpscoutLink
 */
export interface HelpscoutLink {
}

/**
 * Check if a given object implements the HelpscoutLink interface.
 */
export function instanceOfHelpscoutLink(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function HelpscoutLinkFromJSON(json: any): HelpscoutLink {
    return HelpscoutLinkFromJSONTyped(json, false);
}

export function HelpscoutLinkFromJSONTyped(json: any, ignoreDiscriminator: boolean): HelpscoutLink {
    return json;
}

export function HelpscoutLinkToJSON(value?: HelpscoutLink | null): any {
    return value;
}

